import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import InfoIcon from 'components/core/InfoIcon';
import { cx, css } from 'emotion';
import { colorTextGrey, colorTextBlack } from 'styles/base';

const infoTextStyles = css`
    color: ${colorTextGrey};
    margin-left:.5em;
`;

export default class InfoBoxLabel extends React.Component {
    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
        message: PropTypes.any,
        width: PropTypes.string,
        className: PropTypes.string,
        tooltipPosition: PropTypes.string,
        labelWrap: PropTypes.bool,
        hideColon: PropTypes.bool,
        infoIcon: PropTypes.bool,
        extraBold: PropTypes.bool,
        alignTop: PropTypes.bool
    };

    static defaultProps = {
        infoIcon: true,
        extraBold: false
    };

    render() {
        const style = {};
        if (this.props.width) {
            style.width = this.props.width;
        }
        let message = '';
        if (this.props.message) {
            message = this.props.message;
        }

        let className = 'infobox';
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }

        if (this.props.alignTop) {
            className += ` ${css`align-self: flex-start !important; padding-top: 3px;`}`;
        }

        let labelClass = this.props.labelWrap ? 'form-label' : 'form-label nowrap';
        labelClass = cx(labelClass, css`width: 100% !important;`);
        if (this.props.extraBold) {
            labelClass = cx(labelClass, css`font-weight: 900 !important; color: ${colorTextBlack} !important`);
        }
        const colon =  this.props.hideColon ? '' : ':';

        return (
            <Flexbox style={style} className={className} flexDirection="row">
                {this.props.infoIcon &&
                    <InfoIcon
                        message={message}
                        tooltipPosition={this.props.tooltipPosition}
                    />
                }
                {this.props.label &&
                    <div className={labelClass}>{this.props.label}{colon}</div>
                }
                {!this.props.infoIcon &&
                    <div className={cx(infoTextStyles)}>{message}</div>
                }
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/InfoBoxLabel.js